import React, { useEffect, useState } from 'react';
import { decodeToken, getToken } from '../utils/TokenUtils';
import { API_URL } from '../constants/api';
import { useTranslation } from 'react-i18next';
import { loadTranslations } from '../i18n';
const PrintTableWithHeader = () => {
  const token = getToken();

  const companyLogo = decodeToken(token, 'logo');
  const companyName = decodeToken(token, 'companyName');
  const companyAddress = decodeToken(token, 'address');
  const companyPhone = decodeToken(token, 'phone');
  const companyEmail = decodeToken(token, 'email');
  const companyUsername = decodeToken(token, 'username');
  const storedData = localStorage.getItem('printData');
  const parsedData = JSON.parse(storedData);

 // const { title, tableData, reportHeader } = parsedData || {};
const { title, tableData, reportHeader, reportFooter } = parsedData || {};
  const { t } = useTranslation();
  const theadData =
    tableData && tableData.length > 0
      ? Object.keys(tableData[0]).filter(
        (key) =>
          key !== 'color' &&
          key !== 'can_edit_delete' &&
          !key.startsWith('delete') &&
          !key.includes('hide') &&
          key !== 'update_route_id' &&
          key !== 'update_table'
      )
      : [];

  // .map(key=>key.split('~')[0])
  //console.log(title,logo,tableData)
console.log("thead data: ",theadData);
  // const theadData = Object.keys(tableData[0]);
  const [bannerLoaded, setBannerLoaded] = useState(false);

  const styles = {
    printPage: {
      position: 'absolute',
      left: 0,
      top: 0,
      width: '100%',
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      border: '1px solid black',
    },
    cell: {
      border: '1px solid black',
      textAlign: 'left',
    },
    header: {
      textAlign: 'center',
      marginBottom: '20px',
    },
    logo: {
      width: '100%',
      height: '150px',
    },
  };
  useEffect(() => {
     if (tableData.length > 0 && theadData.length > 0 && bannerLoaded) {
       const t = setTimeout(() => {
         window.print();
       }, 200);
   
       return () => clearTimeout(t);
     }
   }, [tableData, theadData, bannerLoaded]);
  // return (
  //   <div>
  //     {/* Header and Table Section */}
  //     <div style={styles.printPage}>
  //       <header style={styles.header}>
  //         <img
  //           src={`${API_URL}/${companyBanner}`}
  //           alt="Company Banner"
  //           style={styles.logo}
  //           onLoad={() => setBannerLoaded(true)}
  //           onError={() => setBannerLoaded(true)}
  //         />
  //       </header>
  //       <div className="" style={{ paddingLeft: '20px' }}>
  //         <center>
  //           <h2>{title}</h2>
  //         </center>
  // AUTO PRINT
  useEffect(() => {
    setTimeout(() => {
      window.print();
    }, 500);
  }, []);
  useEffect(() => {
      // Load the translations from the API (replace 'en' with your desired language code)
      loadTranslations(); // Load English translations (or any other language)
    }, []);
  return (
    <>
      {/* PRINT CSS */}
      <style>
        {`
        @media print {
          body * {
            visibility: hidden;
          }

          #print-area, #print-area * {
            visibility: visible;
          }

          #print-area {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
          }

          .no-print {
            display: none !important;
          }
        }
      `}
      </style>

      <div id="print-area" style={{ padding: '5px 8px', fontFamily: 'Times New Roman' }}>

        {/* HEADER */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          borderBottom: '2px solid #000',
          marginBottom: '10px',
          paddingBottom: '10px'
        }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img
              src={`${API_URL}/${companyLogo}`}
              alt="logo"
              style={{ width: '60px', marginRight: '10px' }}
            />
            <div>
              <div style={{ fontWeight: 'bold' }}>{companyName}</div>
              <div style={{ fontSize: '12px' }}>{companyAddress}</div>
            </div>
          </div>

          <div style={{ textAlign: 'right', fontSize: '12px' }}>
            <div>Tel: {companyPhone}</div>
            <div>Username: {companyUsername}</div>
            <div>Email: {companyEmail}</div>
          </div>
        </div>

        {/* TITLE */}
        <h2 style={{ textAlign: 'center' }}>{title}</h2>

        {/* REPORT HEADER */}
        {/* REPORT HEADER — 2 columns */}
        {reportHeader && (
          <div style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '4px 40px',
            marginBottom: '16px',
            fontSize: '12px',
            borderBottom: '1px solid #ccc',
            paddingBottom: '10px'
          }}>
            {reportHeader.map((item, index) =>
              Object.entries(item).map(([key, value], i) => (
                <div key={`${index}-${i}`}>
                  <strong>{key}:</strong> {value}
                </div>
              ))
            )}
          </div>
        )}  

        {/* TABLE */}
        <table
          style={{
            width: '100%',
            borderCollapse: 'collapse',
            fontSize: '12px'
          }}
        >
          <thead>
            <tr>
              {theadData.map((heading) => {
                return (
                <th
                  key={heading}
                  style={{
                    border: '0.6px solid #000',
                    padding: '6px',
                    backgroundColor: '#eee'
                  }}
                >
                  {t(heading.split('~')[0].charAt(0).toUpperCase() + heading.split('~')[0].slice(1))}
                </th>)
})} 
            </tr>
          </thead>
         

          <tbody>
            {tableData &&
              tableData.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {theadData.map((key, colIndex) => (
                    <td
                      key={colIndex}
                      style={{
                        border: '0.6px solid #000',
                        padding: '3px',
                        textAlign: 'center'
                      }}
                    >
                      {(() => {
                        const value = row[key];

                        // ✅ IMAGE DETECTION
                        const isImage =
                          typeof value === 'string' &&
                          (
                            value.startsWith('http') ||
                            value.startsWith('data:image') ||
                            value.includes('.jpg') ||
                            value.includes('.png') ||
                            value.includes('.jpeg')
                          );

                        if (isImage) {
                          const imgSrc = value.startsWith('http')
                            ? encodeURI(value)
                            : `${API_URL}/${encodeURI(value)}`;

                          return (
                            <img
                              src={imgSrc}
                              alt="img"
                              style={{
                                width: '60px',
                                height: '60px',
                                objectFit: 'cover'
                              }}
                              onError={(e) => {
                                e.target.style.display = 'none';
                              }}
                            />
                          );
                        }

                        // HTML LINKS SUPPORT
                        if (typeof value === 'string' && value.includes('<a')) {
                          return (
                            <span
                              dangerouslySetInnerHTML={{ __html: value }}
                            />
                          );
                        }
                        if (
                typeof value === 'string' &&
                value.includes('<') &&
                value.includes('>')
              ) {
                console.log('this');
                return <div dangerouslySetInnerHTML={{ __html: value }} />;
              
            }
                        return value;
                      })()}
                    </td>
                  ))}
                </tr>
              ))}
          </tbody>
        </table>

                {/* FOOTER - SIGNATURES */}
        {reportFooter && reportFooter.length > 0 && (
          <div style={{
            display: 'grid',
            gridTemplateColumns: `repeat(${Object.keys(reportFooter[0]).length}, 1fr)`,
            gap: '0 40px',
            marginTop: '80px',
            paddingTop: '10px',
            fontSize: '13px'
          }}>
            {Object.entries(reportFooter[0]).map(([key, value], i) => (
              <div key={i} style={{ textAlign: 'center' }}>
                {/* Signature Line */}
                <div style={{
                  borderTop: '2px solid #000',
                  marginBottom: '8px',
                  width: '100%'
                }}></div>
                {/* Name */}
                <div style={{ fontWeight: 'bold' }}>{value}</div>
                {/* Title/Role */}
                <div style={{ fontSize: '12px', color: '#555' }}>{key}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default PrintTableWithHeader;